module.exports = __webpack_public_path__ + "static/img/dongjie.e62413bd.png";